import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter className="type"
      options={{
        strings: [
          "Fornt-end Developer",
         
          "MERN Stack Developer",
          "Software Developer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
